import { DateService } from '@aca-new/app/shared/classes/date-service.class';

/**
 * @returns {DateService} date service
 */
export function dateFactory(): DateService {
  return new DateService();
}
